import { FeeTypeModel } from "@admin_api/models/fee-type-model";

export class FeeTypesState {
    loading = false;
    error = null;
    record: Array<FeeTypeModel> = [];
}
